<section fxLayout="column">
  <ng-container *ngIf="!isDesktopDevice">
    <app-user-menu></app-user-menu>
  </ng-container>

  <ng-container *ngIf="actions">
    <button
      mat-menu-item
      *ngFor="let action of actionList"
      (click)="setAction(action.function)"
    >
      <!-- TODO: -->
      <mat-icon>{{ action.icon }}</mat-icon>

      <span>{{ action.label }}</span>
    </button>
  </ng-container>
</section>
